import React from 'react';
import { 
  Cloud, 
  Server, 
  Database, 
  Globe, 
  Settings,
  Monitor,
  HardDrive,
  Layers,
  Code,
  Shield,
  Zap,
  Package
} from 'lucide-react';

// Système d'icônes harmonisé avec Lucide React (stroke/linéaires)
export const ServiceIcons = {
  // Services principaux
  CloudVPS: ({ className = "w-5 h-5", strokeWidth = 1.5, ...props }) => (
    <Cloud className={className} strokeWidth={strokeWidth} {...props} />
  ),
  
  Orchestrator: ({ className = "w-5 h-5", strokeWidth = 1.5, ...props }) => (
    <Settings className={className} strokeWidth={strokeWidth} {...props} />
  ),
  
  DBaaS: ({ className = "w-5 h-5", strokeWidth = 1.5, ...props }) => (
    <Database className={className} strokeWidth={strokeWidth} {...props} />
  ),
  
  Domains: ({ className = "w-5 h-5", strokeWidth = 1.5, ...props }) => (
    <Globe className={className} strokeWidth={strokeWidth} {...props} />
  ),
  
  DedicatedServer: ({ className = "w-5 h-5", strokeWidth = 1.5, ...props }) => (
    <Server className={className} strokeWidth={strokeWidth} {...props} />
  ),
  
  CMSaaS: ({ className = "w-5 h-5", strokeWidth = 1.5, ...props }) => (
    <Code className={className} strokeWidth={strokeWidth} {...props} />
  ),

  // Icônes système et OS
  Linux: ({ className = "w-4 h-4", strokeWidth = 1.5, ...props }) => (
    <Monitor className={className} strokeWidth={strokeWidth} {...props} />
  ),
  
  Windows: ({ className = "w-4 h-4", strokeWidth = 1.5, ...props }) => (
    <Monitor className={className} strokeWidth={strokeWidth} {...props} />
  ),
  
  // Icônes de configuration
  Storage: ({ className = "w-4 h-4", strokeWidth = 1.5, ...props }) => (
    <HardDrive className={className} strokeWidth={strokeWidth} {...props} />
  ),
  
  Performance: ({ className = "w-4 h-4", strokeWidth = 1.5, ...props }) => (
    <Zap className={className} strokeWidth={strokeWidth} {...props} />
  ),
  
  Security: ({ className = "w-4 h-4", strokeWidth = 1.5, ...props }) => (
    <Shield className={className} strokeWidth={strokeWidth} {...props} />
  ),
  
  Container: ({ className = "w-4 h-4", strokeWidth = 1.5, ...props }) => (
    <Package className={className} strokeWidth={strokeWidth} {...props} />
  ),
  
  Cluster: ({ className = "w-4 h-4", strokeWidth = 1.5, ...props }) => (
    <Layers className={className} strokeWidth={strokeWidth} {...props} />
  )
};

// Composant wrapper pour une utilisation cohérente
export const ServiceIcon = ({ 
  name, 
  size = 'md', 
  variant = 'default',
  className = '',
  ...props 
}) => {
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  };

  const strokeWidths = {
    thin: 1,
    normal: 1.5,
    thick: 2
  };

  const IconComponent = ServiceIcons[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in ServiceIcons`);
    return <div className={`${sizes[size]} bg-gray-300 rounded`} />;
  }

  return (
    <IconComponent
      className={`${sizes[size]} ${className}`}
      strokeWidth={strokeWidths[variant] || strokeWidths.normal}
      {...props}
    />
  );
};

export default ServiceIcons;
